import React, { Component } from "react"
import { Link } from 'gatsby';
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import "./casestudygnd.scss"

import imgQuote from "../images/quotation_mark.webp"

export default ({ pageContext }) => (
    <Layout>
        <SEO
            title={pageContext.yoast.title}
            description={pageContext.yoast.metadesc}
            ogimg={pageContext.yoast.opengraph_image}
            link={pageContext.link}
        />
        <div className="case-study-gnd-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div
                        className="header-container"
                        style={{
                            backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
                        }}
                    >
                        <img src={imgQuote} alt="" />
                        <h2>{pageContext.acf.header_text}</h2>
                    </div>
                </div>
            </div>
            <div className="container detail-wrapper">
                <div className="row">
                    <div className="col-12 col-md-8">
                        <img
                            src={
                                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp
                                    .fluid.src
                            }
                            className="client-logo"
                            width={pageContext.acf.client_logo.media_details.width}
                            height={pageContext.acf.client_logo.media_details.height}
                            alt={pageContext.yoast.opengraph_title}
                        />
                    </div>
                    <div className="col-md-4">
                        <a href="https://www.meritmile.com/uploads/2026/01/giesecke-devrient-case-study.pdf" className="btn downloadBtn" target="_blank" rel="nofollow noopener noreferrer" style={{ marginTop: '4em'}}>Download the PDF here</a>
                    </div>
                    <div className="col-12">
                        <div className="bar"></div>
                    </div>
                    <div className="col-12">
                        <div
                            className="first-paragraph"
                            dangerouslySetInnerHTML={{
                                __html: pageContext.acf.first_paragraph,
                            }}
                        />
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12">
                        <img
                            src="https://www.meritmile.com/uploads/2026/01/gnd-challenge.webp"
                            className="results-image img-fluid"
                            alt="Giesecke+Devrient Challenge"
                            width="1140px"
                            style={{ marginTop: '2em', marginBottom: '4em', scale: '1.15'}}
                        />
                    </div>
                </div>
                <div className="row margin-b">                
                    <div className="col-12">
                        <h3>Challenge</h3>
                    </div>
                </div>
                <div className="row margin-b">                
                    <div className="col-12 col-md-6">
                        <p>Expanding the presence of a German-based financial security technology leader into the U.S. market posed several challenges. These included navigating strict American regulatory frameworks, earning trust and credibility in a crowded industry, and </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <p>translating brand messaging to resonate with U.S. audiences. Cultural nuances and localization, along with the need to develop key relationships with media and industry stakeholders, required a strategic, multi-faceted approach.</p>
                    </div>
                </div>
              </div>
              <div className="container detail-wrapper">
                <div className="row margin-b">
                  <div className="col-12 col-md-6">
                      <img
                          src="https://www.meritmile.com/uploads/2026/01/gnd-solutions.webp"
                          className="results-image img-fluid"
                          alt="Giesecke+Devrient Solutions"
                          width="600px"
                          style={{ marginBottom: '2em', marginLeft: '-4em' }}
                      />
                  </div>
                  <div className="col-12 col-md-6">
                      <h3>Solutions</h3>
                      <p>G+D partnered with Merit Mile to launch an integrated Public Relations program focused on thought leadership and strategic storytelling. Merit Mile created messaging frameworks for each of G+D’s core business units—Digital Security, Financial Platforms, and Currency Technology—and developed unique story angles. Merit Mile also coordinated and secured press briefings at high-impact industry events, helping position G+D as a trusted leader in financial security and payments innovation.</p>
                  </div>
                </div>
              </div>
              <div className="container detail-wrapper">
                <div className="row margin-b">
                  <div className="col-12">
                      <p>Tapping into G+D’s internal data and insights, the PR strategy emphasized timely, authoritative content that connected G+D's technology leadership with relevant U.S. market trends. Merit Mile placed stories in top-tier outlets and podcasts, reinforcing G+D's credibility across key verticals.</p>
                  </div>
                </div>
              </div>
              
              <div className="dualgraybgs margin-b">
                <div className="leftGray">
                    <div className="wrap">
                      <h3>Results</h3>
                      <p>The PR program helped G+D significantly increase its share of voice and visibility in the U.S. financial and security technology landscape.</p>
                    </div>
                </div>
                <div className="rightGray">
                    <div className="wrap">
                      <h3>Campaign Metrics:</h3>
                      <p>
                        Total brand mentions: <strong>172</strong><br />
                        Total impressions: <strong>27,397,704</strong><br />
                        Total ad equivalency: <strong>$471,373</strong><br />
                        Total ROI: <strong>4.62X monthly spend</strong>
                      </p>
                    </div>
                </div>
              </div>

              <div className="container detail-wrapper">
                <div className="row">
                    <div className="col-12">
                        <h3>Notable Coverage Highlights:</h3>
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 col-md-6">
                      <div className="card-sample">
                        <div className="card-top">
                          <p><strong>Efficiency through automation: Elevating casino count room performance while reducing cost and risk</strong></p>
                          <ul>
                            <li>Impressions: <strong>56,500</strong></li>
                            <li>Equivalency: <strong>$3,500</strong></li>
                          </ul>
                        </div>
                        <div className="card-bottom">
                          <img
                              src="https://www.meritmile.com/uploads/2026/01/efficiency-through-automation.webp"
                              className="img-fluid"
                              alt="Efficiency through automation"
                              width="560px"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="card-sample">
                        <div className="card-top">
                          <p><strong>Smarter verification, safer transactions: A path forward for auto fraud prevention</strong></p>
                          <ul>
                            <li>Impressions: <strong>48,000</strong></li>
                            <li>Equivalency: <strong>$3,500</strong></li>
                          </ul>
                        </div>
                        <div className="card-bottom">
                          <img
                              src="https://www.meritmile.com/uploads/2026/01/smarter-verification.webp"
                              className="img-fluid"
                              alt="Smarter verification"
                              width="560px"
                          />
                        </div>
                      </div>
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 col-md-6">
                      <div className="card-sample">
                        <div className="card-top">
                          <p><strong>How the New SGP.32 Standard is Modernizing Global IoT Deployments</strong></p>
                          <ul>
                            <li>Impressions: <strong>48,100</strong></li>
                            <li>Equivalency: <strong>$3,850</strong></li>
                          </ul>
                        </div>
                        <div className="card-bottom">
                          <img
                              src="https://www.meritmile.com/uploads/2026/01/new-sgp-standard.webp"
                              className="img-fluid"
                              alt="How the New SGP.32 Standard"
                              width="560px"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="card-sample">
                        <div className="card-top">
                          <p><strong>Why 'green' cards are falling short of revenue expectations</strong></p>
                          <ul>
                            <li>Impressions: <strong>68,000</strong></li>
                            <li>Equivalency: <strong>$4,225</strong></li>
                          </ul>
                        </div>
                        <div className="card-bottom">
                          <img
                              src="https://www.meritmile.com/uploads/2026/01/why-green-cards.webp"
                              className="img-fluid"
                              alt="Smarter verification"
                              width="560px"
                          />
                        </div>
                      </div>
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 col-md-6">
                      <div className="card-sample">
                        <div className="card-top">
                          <p><strong>What Can Be Done to Reduce America's $100 Billion Healthcare Fraud Problem</strong></p>
                          <ul>
                            <li>Impressions: <strong>48,000</strong></li>
                            <li>Equivalency: <strong>$3,000</strong></li>
                          </ul>
                        </div>
                        <div className="card-bottom">
                          <img
                              src="https://www.meritmile.com/uploads/2026/01/reduce-healthcare-fraud.webp"
                              className="img-fluid"
                              alt="What Can Be Done"
                              width="560px"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="card-sample">
                        <div className="card-top">
                          <p><strong>What new US banknotes mean for banks' counterfeit prevention</strong></p>
                          <ul>
                            <li>Impressions: <strong>55,400</strong></li>
                            <li>Equivalency: <strong>$2,650</strong></li>
                          </ul>
                        </div>
                        <div className="card-bottom">
                          <img
                              src="https://www.meritmile.com/uploads/2026/01/what-new-us-banknotes.webp"
                              className="img-fluid"
                              alt="What new US banknotes"
                              width="560px"
                          />
                        </div>
                      </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '4em' }}>
                    <div className="col-12">
                      <h3>Merit Mile Turnkey Campaign Services</h3>
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 col-md-6">                        
                        <ul>
                            <li>Media relations and PR strategy</li>
                            <li>Thought leadership development</li>
                            <li>Messaging frameworks and positioning</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">                        
                        <ul>
                            <li>Executive communications and interviews</li>
                            <li>Content creation and placement</li>
                            <li>Campaign analytics and reporting</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="fullWidthGrayCTA">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h5>Learn more about how Merit Mile can support your vertical content marketing, lead generation, and sales goals by contacting <a href="mailto:Hello@MeritMile.com?subject=Giesecke+Devrient%20Case%20Study%20Inquiry"><b style={{ color: "black" }}>hello@meritmile.com.</b></a></h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="yourteam-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3>Your Merit Mile Team</h3>
                        </div>
                    </div>
                    <div className="row margin-b">
                        <div className="col-12">
                            <div className="team-cards">
                                <div className="team-card">
                                    <img
                                        src="https://www.meritmile.com/uploads/2026/01/js-thumb.webp"
                                        alt="John Sternal"
                                        className="img-fluid"
                                    />
                                    <h4>John Sternal</h4>
                                    <p>
                                        Partner, PR, Social,<br />
                                        Research
                                    </p>
                                </div>
                                <div className="team-card">
                                    <img
                                        src="https://www.meritmile.com/uploads/2026/01/jb-thumb.webp"
                                        alt="Justin Baronoff"
                                        className="img-fluid"
                                    />
                                    <h4>Justin Baronoff</h4>
                                    <p>
                                        PR Account<br />
                                        Executive
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fullWidthImageWrapper">
                <img
                    src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
                    alt="Merit Mile Icon Divider"
                    className="img-fluid"
                />
            </div>
            <div className="about-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <h2>About Merit Mile</h2>
                        </div>
                    </div>
                    <div className="row margin-b">
                        <div className="col-md-6">
                            <p>Established in 2007 in Boca Raton, FL, Merit Mile is a marketing services provider focused on helping companies and corporate marketing departments build brands, drive sales revenue, and garner publicity in their respective industries. Our unique differentiator at Merit Mile is our ability to 100% own the message, the publicity, and the demand generation aspects of the corporate marketing function. Clients hire us and rehire us for our ability to refine their messaging/value proposition, develop top and mid-funnel leads, and get the type of editorial publicity that differentiates them from their competitors. From branding to PR to demand generation, Merit Mile is the high-octane fuel that invigorates corporate growth engines. To learn more, please email us at Hello@MeritMile.com, call us at 1-561-362-888, or visit us at www.MeritMile.com. </p>
                        </div>
                        <div className="col-md-6"><img className="img-fluid" src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp" alt="Merit Mile Headquarter in Boca Raton, FL" /></div>
                    </div>
                </div>
            </div>
            <div className="container quote-wrapper">
                <div className="row">
                    <div className="col-12">
                        <p>
                            For more insights and to connect<br />
                            with Merit Mile <a href="mailto:Hello@MeritMile.com?subject=Teldoc%20Health%20Microsoft%20Case%20Study%20Inquiry"><b style={{ color: "black" }}>email us here</b>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
)